export const PENDING_KEY = 'dq:txPending';
export const PENDING_TIMEOUT = 5 * 60 * 1000; // 5 min fallback

export const POINTS = {
  dailyLogin: 15,
  dailyPlay: 20,
  dailyWin: 30,
  weeklyStreak: 1000,
};

export const TARGET_STREAK = 7;

export enum QuestAccent {
  Bronze = 'bronze',
  Silver = 'silver',
  Gold = 'gold',
  Rainbow = 'rainbow',
  Ice = 'ice',
}

export interface IQuestAccent {
  [QuestAccent.Bronze]: string;
  [QuestAccent.Silver]: string;
  [QuestAccent.Gold]: string;
  [QuestAccent.Rainbow]: string;
  [QuestAccent.Ice]: string;
}
